var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6007_98370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 4.52344H20.829C21.4218 4.52344 21.9025 4.99172 21.9025 5.56935V14.4575C21.9025 15.0351 21.4218 15.5034 20.829 15.5034H9.98601",
    stroke: "black",
    strokeWidth: 0.325528,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8296 4.52344H9.69431C9.10152 4.52344 8.78427 5.00038 8.78427 5.5883L8.07617 6.65316H21.9037V5.5883C21.9037 4.99984 21.4229 4.52344 20.8302 4.52344H20.8296Z",
    stroke: "black",
    strokeWidth: 0.325528,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.281 5.60938H20.8765C20.8816 5.60938 20.8857 5.60525 20.8857 5.60017V5.57256C20.8857 5.56748 20.8816 5.56336 20.8765 5.56336H20.281C20.276 5.56336 20.2718 5.56748 20.2718 5.57256V5.60017C20.2718 5.60525 20.276 5.60938 20.281 5.60938Z",
    stroke: "black",
    strokeWidth: 0.162764,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0125 5.60938H19.608C19.6131 5.60938 19.6172 5.60525 19.6172 5.60017V5.57256C19.6172 5.56748 19.6131 5.56336 19.608 5.56336H19.0125C19.0074 5.56336 19.0033 5.56748 19.0033 5.57256V5.60017C19.0033 5.60525 19.0074 5.60938 19.0125 5.60938Z",
    stroke: "black",
    strokeWidth: 0.162764,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7459 5.60938H18.3414C18.3465 5.60938 18.3506 5.60525 18.3506 5.60017V5.57256C18.3506 5.56748 18.3465 5.56336 18.3414 5.56336H17.7459C17.7408 5.56336 17.7367 5.56748 17.7367 5.57256V5.60017C17.7367 5.60525 17.7408 5.60938 17.7459 5.60938Z",
    stroke: "black",
    strokeWidth: 0.162764,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0957 8.08398H20.7516",
    stroke: "black",
    strokeWidth: 0.162764,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0957 9.10352H20.7516",
    stroke: "black",
    strokeWidth: 0.162764,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0527 10.1211H20.7086",
    stroke: "black",
    strokeWidth: 0.162764,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91309 11.1387H20.7516",
    stroke: "black",
    strokeWidth: 0.162764,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91309 12.1582H20.7516",
    stroke: "black",
    strokeWidth: 0.162764,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91309 13.1777H20.7516",
    stroke: "black",
    strokeWidth: 0.162764,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91309 14.1973H20.7516",
    stroke: "black",
    strokeWidth: 0.162764,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.27356 10.498L0.0146484 15.7574H2.20934C2.98728 15.7574 3.72299 15.4039 4.2048 14.7981L5.9794 12.5682L4.27302 10.498H4.27356Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.488292,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63064 10.498L12.8896 15.7574H10.6082C9.88498 15.7574 9.20178 15.4288 8.75353 14.8658L6.9248 12.5682L8.63118 10.498H8.63064Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.488292,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.607422 4.86035L6.45956 11.9804L15.9502 0.244141H14.0316C13.0279 0.244141 12.0811 0.707548 11.4699 1.4974L6.48826 7.93746L5.35789 6.4866C4.55884 5.46072 3.32561 4.86035 2.01875 4.86035H0.607964H0.607422Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.488292,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.27356 10.4961L0.0146484 15.7554H2.20934C2.98728 15.7554 3.72299 15.4019 4.2048 14.7961L5.9794 12.5663L4.27302 10.4961H4.27356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63162 10.4961L12.8905 15.7554H10.6092C9.88596 15.7554 9.20276 15.4268 8.75451 14.8638L6.92578 12.5663L8.63216 10.4961H8.63162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.607422 4.86035L6.45956 11.9804L15.9502 0.244141H14.0316C13.0279 0.244141 12.0811 0.707548 11.4699 1.4974L6.48826 7.93746L5.35789 6.4866C4.55884 5.46072 3.32561 4.86035 2.01875 4.86035H0.607964H0.607422Z",
    fill: "url(#paint0_linear_6007_98370)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6007_98370",
    x1: 0.607422,
    y1: 6.11198,
    x2: 15.9502,
    y2: 6.11198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97B24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6007_98370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentxIcon);
export default __webpack_public_path__ + "static/media/contentx_icon.2c67e5b478658f1844ed29041af9b585.svg";
export { ForwardRef as ReactComponent };